import CrudModel from '@/orm/models/CrudModel';

export default class VacanciesList extends CrudModel {
  static entity = 'VacanciesList'

  static url = { index: 'vacancy_lists' }

  static primaryKey = 'id'

  static fields() {
    return {
      id: this.attr(null),
      type: this.attr(null),
      title: this.attr(null),
      description: this.attr(null),
      listData: this.attr({}),
      vacancies: this.attr([]),
      allNotActive: this.boolean(false),
    };
  }
}
